<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Read how other tennis clubs are benefiting from Str8 Sets for Clubs' },
            meta: [
				{ name: 'description', content: 'Don\'t take our word for it, we love tennis and that\'s why we created Str8 Sets. Learn why other clubs around the world choose Str8 Sets to help them manage their tennis club operations. Learn more...', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/case-studies_clubs' },
                { property: 'og:title', content: 'Read how other tennis clubs are benefiting from Str8 Sets for Clubs' },
                { property: 'og:description', content: 'Don\'t take our word for it, we love tennis and that\'s why we created Str8 Sets. Learn why other clubs around the world choose Str8 Sets to help them manage their tennis club operations. Learn more...' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and Screenshot' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/case-studies_clubs' },
				{ name: 'twitter:title', content: 'Read how other tennis clubs are benefiting from Str8 Sets for Clubs' },
                { name: 'twitter:description', content: 'Don\'t take our word for it, we love tennis and that\'s why we created Str8 Sets. Learn why other clubs around the world choose Str8 Sets to help them manage their tennis club operations. Learn more...' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and Screenshot' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/case-studies_clubs', id: 'canonical' }
			]
        }
    })
</script>

<template>
    <div>
        <div class="parallax image-clay-court height height-350">
            <div class="container">
                <div class="feature-page-header">
                    <h1>Club Management</h1>
                    <h2>Case Studies</h2>
                </div>
            </div>
        </div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h1>Claremont Railway LTC</h1>
                                <h4>Dublin, Ireland</h4>
                                <br/>
                                <p>Located in the heart of Dublin, Ireland, Claremont Railway LTC boasts <b>one of the largest tennis 
                                club memberships in the country</b>. The club has a high utilization of its 7 tennis savannah 
                                courts, 3 grass courts, and tennis wall. To facilitate a growing membership, the club needed 
                                a comprehensive management solution for both its members and management. Claremont 
                                is managed by a committee of volunteers who each have their own busy lives.</p>
                                <p> They needed to find a solution that allowed them full control with minimal effort.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>The Visionaries</h2>
                                <p>The club’s committee, led by Suzanne, Killian, Will, and Ken, had been looking for a new club 
                                management tool for a while when they discovered Str8 Sets. As it looked like it met all of 
                                their requirements, they got in contact with the Str8 Sets team. After a demonstration of the 
                                system, the committee decided to go with Str8 Sets.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>Areas of Improvements - Before Str8 Sets</h2>
                            <h3>Membership Management / Subscription Connection</h3>
                                <p>The club’s treasurer was also responsible for membership collection. Before Str8 Sets, this 
                                was a difficult job. The treasurer had to keep track of all members subscriptions on a monthly 
                                basis, collecting fees in several ways (manual DDs, bank transfers, cheque, and cash) to ensure 
                                all of those using the club kept their memberships up to date, and making sure everything 
                                balanced. Late members had to be contacted and reminded to pay their fees. This required a 
                                lot of effort by the treasurer and on occasion led to lost revenue. There was also no simple 
                                way of ensuring that only current members could use the club.</p>
                            <h3>Court Management</h3>
                                <p>With a growing and active membership base, the club has to manage the courts and bookings 
                                for all of their many members. The courts are free for members during the day but there is a 
                                charge for playing under lights. The club previously used another club management system 
                                for booking courts which did not facilitate subscription payments / block bookings and which 
                                could only be used on certain PCs for full functionality. As a result, the courts were not being 
                                utilized as efficiently as they could have been.<p>
                                <p>Naturally, this method became untenable as the club got busier. The club needed to find a 
                                solution for court booking, especially given its active membership and club organized 
                                competitions / tennis lessons, which regularly require block booking of some of the courts.</p>
                            <h3>Member Communication</h3>
                                <p>The club had a system in place for sending emails to members and it 
                                previously had a system for mass text messaging as well but the system was 
                                expensive and had been discontinued by the club. However, as members 
                                don’t always read their emails, the club was left requiring a better solution for crucial 
                                communications.</p>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>With Str8 Sets</h2>
                            <p>The club committee immediately recognized the value of having <b>one system that can fully 
                            integrate all of their needs</b>. There would be no need to define their membership in multiple 
                            systems for different purposes. Furthermore, the competitive price structure of Str8 Sets 
                            made it much more attractive than other alternatives on the market.</p>
                            <h3>Membership Management / Subscription Collection</h3>
                                <p><b>Membership fee payment is now paid on the app</b>. The club requires automatic withdrawal of 
                                membership (Direct debit) from members regardless of their billing cycle. Hence, all a 
                                member had to do is download the app, pay once for their billing cycle and forget it!  The 
                                payment is made automatically every month or every year depending on the member’s 
                                chosen billing cycle. Members can change their billing cycle on the app if they wish.</p>
                                <p>Reminders and receipts for payments are automatically handled by Str8 Sets. Furthermore, 
                                members are notified by Str8 Sets if they need to change their credit card if it’s about to 
                                expire. Now, once a month, membership fees are collected and sent directly to the club’s 
                                Stripe account,  which is setup to send the money immediately to their bank account. This 
                                saved the club’s treasurer many hours of work every month.</p>
                                <p>At the end of each financial cycle, the treasurer downloads a spreadsheet from Str8 Sets 
                                including all the transactions that took place, using it to reconcile the funds received from 
                                Stripe.</p>
                            <h3>Court Management</h3>
                                <p>Within a couple of months of adoption, the club had <b>thousands of court bookings on Str8 
                                Sets</b>, significantly increased on the previous system. Not only does Str8 Sets allow them to 
                                offer an intuitive solution to their members, it also enables them to view their court utilization 
                                and drill into the details of the bookings by member/guest or booking type (e.g. Coaching, 
                                Matcha, Competition).</p>
                                <p>Flexible booking rules allow the club to control who can book, when they can book and which 
                                courts can be booked by certain membership types.</p>
                            <h3>Member Communications</h3>
                                <p>With Str8 Sets group communication, the club is now able to <b>segment their memberships into 
                                different groups and communicate with them separately</b> by sending messages through the 
                                app. A Communications Admin is now able to decide on whether groups can be used for 
                                announcements, or to have a dialogue with the members. This was the perfect 
                                tool to compliment the club’s email blasts.</p>
                            <p>Having all these features in one place enables the committee to streamline the club 
                            management in an unprecedented manner. This is demonstrated by a happy membership 
                            and a management committee that is spending less time for a better result. </p>
                        </div>
                    </div>
                </div>                

            </div>
        </section>

        <div class="parallax image-clay-court height height-150"></div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h1>Hampton Tennis Club (Hampton TC) </h1>
                                <h4>Hampton, Melbourne, Australia</h4>
                                <br/>
                                <p>Hampton TC is located in the bayside area in Melbourne, Australia. It has a loyal, robust membership 
                                of varying ages and tennis skills. The club had recently transformed itself under new management and 
                                resurfaced all its courts to a hard court surface. The club is vibrant with its active members, internal 
                                competitions, and coaching classes that run daily.</p>
                        </div>
                    </div>
                </div>
                    <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>The Visionaries</h2>
                                <p>The club is managed by Frank and Michael, who are both life-long passionate tennis players 
                                and currently coaching club members from beginners, to juniors and high prospect players.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>Areas of Improvements - Before Str8 Sets</h2>
                            <h3>Membership Management</h3>
                                <p>Frank takes care of the club’s operations in general, which includes membership management. To 
                                accommodate his members, he decided to offer different billing cycles for membership. Hence, some 
                                members were paying annually while others paid monthly. A significant number of members chose the monthly 
                                cycle.</p>
                                <p>To manage the membership collection efficiently, the club looked for online solutions. They chose a 
                                generic solution for clubs, not specifically Tennis clubs. However, this was not ideal. The chosen 
                                solution was expensive, didn’t handle the various billing cycles based on membership types and didn’t 
                                do some of the tasks that Frank needed like letting people know that they should update their credit 
                                card details because it was about to expire. This left him with more work than needed while spending too 
                                much money on that solution’s high processing fees.</p>
                            <h3>Court Management</h3>
                                <p>Like any tennis club with a vibrant membership, Hampton TC had to manage the courts and bookings for 
                                their members. The courts are free for members during the day but there is a charge for playing under 
                                lights. The courts were managed manually on paper and people had to call if they wanted to be sure that a 
                                court is available for them to play.</p>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <h2>With Str8 Sets</h2>
                            <p>When Frank and Michael met with Str8 Sets they <b>immediately recognized the value of having one system that 
                            can fully integrate all their needs</b>. There would be no need to define their membership in multiple 
                            systems for different purposes. Furthermore, the competitive price structure of Str8 Sets made it much more 
                            attractive than other alternatives on the market.</p>
                            <h3>Membership Management</h3>
                                <p>Membership fee payment is now paid on the app. The club requires automatic withdrawal of membership (Direct debit) 
                                from members regardless of their billing cycle. Hence, all a member had to do is download the app, pay once for their 
                                billing cycle and forget it! The payment is made automatically every month or every year depending on the member’s chosen 
                                billing cycle. Members can change their billing cycle on the app if they want.</p>
                                <p>Reminders and receipts for payments are automatically handled by Str8 Sets. Furthermore, members are 
                                notified by Str8 Sets if they need to change their credit card if it’s about to expire. This saved Frank 
                                many hours of work every month. Now, once a month, membership fees are collected and sent directly to the 
                                club’s Stripe account, which is setup to send the money immediately to their bank account.</p>
                            <h3>Court Management</h3>
                                <p>Within the first month of using Str8 Sets and even before all the members had downloaded the app, 
                                hundreds of court bookings were made. Members found the experience simple and intuitive. Positive 
                                feedback was received about this experience by the club managers and Str8 Sets. </p>
                                <p>Now, the business rules are setup to allow members to book for free during the day and for a fee under 
                                lights. Furthermore, membership types that are not allowed to book courts (e.g. Social members) are 
                                defined on the system. Naturally, the court booking system on Str8 Sets reuses the membership details 
                                and allows the club manager to define court booking rules for them. </p>
                        </div>
                    </div>
                </div>
                

            </div>
            <div class="spacer-large"></div>
        </section>

        <div class="parallax parallax image-clay-court height-150" ></div>
    </div>
</template>